const max = 9;
var currentPage = 1;
var currentTag = "";

document.addEventListener("DOMContentLoaded", function () {
	var showAllButton = document.getElementById("showAll");
	showAllButton.addEventListener("click", function () {
    resetPills();
    activatePill("showAll");
    currentPage = 1;
    currentTag = "";
		filterArticles();
	});

	var showDogButton = document.getElementById("showDog");
	showDogButton.addEventListener("click", function () {
    resetPills();
    activatePill("showDog");
    currentPage = 1;
    currentTag = "Hund";
		filterArticles();
	});

	var showCatButton = document.getElementById("showCat");
	showCatButton.addEventListener("click", function () {
    resetPills();
    activatePill("showCat");
    currentPage = 1;
    currentTag = "Katze";
		filterArticles();
	});

	var showBarfButton = document.getElementById("showBarf");
	showBarfButton.addEventListener("click", function () {
    resetPills();
    activatePill("showBarf");
    currentPage = 1;
    currentTag = "BARF";
		filterArticles();
	});

	filterArticles();
});

function resetPills() {
	var pills = document.querySelectorAll(".isPill");
	pills.forEach((pill) => {
		pill.classList.remove("active");
	});
}

function activatePill(pill) {
	var pill = document.getElementById(pill);
	pill.classList.add("active");
}

function hideArticles() {
	var articles = document.querySelectorAll(".js-teaser");

	articles.forEach((article) => {
		article.classList.add("js-hide-article");
		article.classList.remove("js-show-article");
	});
}

function showArticles() {

	var articles = document.querySelectorAll("[data-tags='" + currentTag + "']");
  if(currentTag == "") articles = document.querySelectorAll(".js-teaser");

	var startIndex = (currentPage - 1) * max;
	var endIndex = startIndex + max;
  var pageIndex = 0;
  var totalPages = 1;

	articles.forEach((article, index) => {
		if (index >= startIndex && index < endIndex) {
			// article is on page
			article.classList.remove("js-hide-article");
			article.classList.add("js-show-article");
		} else {
			// article is not on page
			article.classList.remove("js-show-article");
			article.classList.add("js-hide-article");
		}

    pageIndex++;
    if(pageIndex > max){
      pageIndex = 0;
      totalPages++;
    }

	});

  createPagination(totalPages);
}

function showAllArticles(){
  var articles = document.querySelectorAll(".js-teaser");

	articles.forEach((article) => {
		article.classList.remove("js-hide-article");
		article.classList.add("js-show-article");
	});
}

function createPagination(totalPages) {

  container = document.querySelector("#pagination");

  container.innerHTML = ''; // Clear the container before adding pagination elements.

  if (totalPages <= 1) {
    return; // No need to create pagination if there's only one page or less.
  }

  // Create previous page link
  if (currentPage > 1) {
    var prevLink = document.createElement('a');
    prevLink.href = 'javascript:void(0);';
    prevLink.textContent = 'Zurück';
    container.appendChild(prevLink);

    prevLink.addEventListener('click', function() {
      currentPage--;
      filterArticles();
    });
  }

  // Create page number links
  for (let i = 1; i <= totalPages; i++) {
    var pageLink = document.createElement('a');
    pageLink.href = 'javascript:void(0);';
    pageLink.textContent = i;
    if (i === currentPage) {
      pageLink.classList.add('active'); // Apply a CSS class to highlight the current page.
    }
    container.appendChild(pageLink);

    pageLink.addEventListener('click', function() {
      currentPage = i;
      filterArticles();
    });

  }

  // Create next page link
  if (currentPage < totalPages) {
    var nextLink = document.createElement('a');
    nextLink.href = 'javascript:void(0);';
    nextLink.textContent = 'Weiter';
    container.appendChild(nextLink);
  }
  nextLink.addEventListener('click', function() {
    currentPage++;
    filterArticles();
  });

}

function filterArticles() {

  hideArticles();
  showArticles();

}
